import { Injectable, Inject } from '@angular/core';
import { Observable, Observer } from 'rxjs';
import { CanActivate, Router, RouterStateSnapshot, ActivatedRouteSnapshot } from '@angular/router';
import { HttpErrorResponse } from '@angular/common/http';

import { AuthService } from './auth.service';
import { AuthConfig } from '../auth.config';
import { FeatureFlagService } from './feature-flag.service';

@Injectable()
export class AuthGuardService implements CanActivate {
  constructor(
    private router: Router,
    private auth: AuthService,
    private feature_flag_service: FeatureFlagService,
    @Inject('config') private config: AuthConfig,
  ) {
  }

  public canActivate(
    route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot,
  ): Observable<boolean> {
    return new Observable<boolean>((observer: Observer<boolean>) => {
      const sessionToken: string = window.sessionStorage.getItem('token');
      if (sessionToken !== undefined) {
        this.auth.login(sessionToken).subscribe(
          (loggedIn: boolean) => {
            observer.next(loggedIn);
            observer.complete();
          },
          (error: HttpErrorResponse) => {
            this.requireLogin(observer, state);
          },
        );
      } else {
        this.requireLogin(observer, state);
      }
    });
  }

  private requireLogin(observer: Observer<boolean>, state: RouterStateSnapshot) {
    this.auth.success_path = state.url;

    // NOTE: This is an entrypoint to redirect user to the login page for whole application
    if (this.feature_flag_service.is_oidc_auth_enabled) {
      this.router.navigate([...this.config.auth_path, 'oidc-login']);
    } else {
      this.router.navigate([...this.config.auth_path, 'login']);
    }

    observer.next(false);
    observer.complete();
  }
}
